import _extends from 'babel-runtime/helpers/extends';
import _defineProperty from 'babel-runtime/helpers/defineProperty';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { PureComponent } from 'react';
import cx from 'classnames';
import isNil from 'lodash/isNil';
import ArrowDown from '@wh/svg-icons/ArrowDownSlim';

import { getAllowedAttributes } from '../props-filters';
import { renderNativeOptions, initiallySelectedIdx, splitToSelectEntries, commonPropTypes } from './helpers';

import * as style from './Select.style';

var SelectNative = function (_PureComponent) {
  _inherits(SelectNative, _PureComponent);

  function SelectNative(props, context) {
    _classCallCheck(this, SelectNative);

    var _this = _possibleConstructorReturn(this, (SelectNative.__proto__ || _Object$getPrototypeOf(SelectNative)).call(this, props, context));

    _this.handleOnChange = function (e) {
      if (e.currentTarget instanceof HTMLSelectElement) {
        var value = e.currentTarget.value;

        _this.selectOption(value);
        var onChange = _this.props.onChange;

        if (onChange) onChange(e);
      }
    };

    _this.selectOption = function (value) {
      _this.setState({
        selectedIdx: _this.childrenValues.indexOf(value)
      });
    };

    _this.handleFocus = function (e) {
      _this.setState({ focused: true });
      var onFocus = _this.props.onFocus;

      if (onFocus) onFocus(e);
    };

    _this.handleBlur = function (e) {
      _this.setState({ focused: false });
      var onBlur = _this.props.onBlur;

      if (onBlur) onBlur(e);
    };

    _this.renderNativeSelect = function () {
      var _this$props = _this.props,
          defaultValue = _this$props.defaultValue,
          value = _this$props.value,
          onSubmit = _this$props.onSubmit,
          onClick = _this$props.onClick,
          onMouseDown = _this$props.onMouseDown,
          onMouseUp = _this$props.onMouseUp,
          onMouseMove = _this$props.onMouseMove,
          onMouseOut = _this$props.onMouseOut,
          onMouseOver = _this$props.onMouseOver,
          disabled = _this$props.disabled,
          name = _this$props.name,
          required = _this$props.required,
          placeholder = _this$props.placeholder;
      var selectedIdx = _this.state.selectedIdx;
      var selectControl = style.selectControl;


      return React.createElement(
        'select',
        {
          'data-test-id': 'SelectNative__select',
          className: selectControl,
          value: _this.childrenValues[selectedIdx] || defaultValue || value,
          name: name,
          tabIndex: 0,
          onChange: _this.handleOnChange,
          onBlur: _this.handleBlur,
          onFocus: _this.handleFocus,
          onClick: onClick,
          onMouseMove: onMouseMove,
          onMouseOut: onMouseOut,
          onMouseOver: onMouseOver,
          onMouseUp: onMouseUp,
          onMouseDown: onMouseDown,
          disabled: disabled,
          onSubmit: onSubmit,
          required: required
        },
        React.createElement(
          'option',
          { value: '' },
          placeholder || ''
        ),
        renderNativeOptions(_this.childrenElements, _this.childrenLabels)
      );
    };

    var children = splitToSelectEntries(props.children);
    _this.childrenElements = children.elements;
    _this.childrenValues = children.values;
    _this.childrenLabels = children.labels;

    var initialSelectedIdx = initiallySelectedIdx(_this.childrenValues, isNil(props.value) ? props.defaultValue : props.value);

    _this.state = {
      focused: false,
      selectedIdx: initialSelectedIdx
    };
    return _this;
  }

  _createClass(SelectNative, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.children !== this.props.children) {
        var children = splitToSelectEntries(nextProps.children);
        this.childrenElements = children.elements;
        this.childrenValues = children.values;
        this.childrenLabels = children.labels;
      }
      if (nextProps.value !== this.props.value && nextProps.value != null) {
        this.selectOption(nextProps.value);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          defaultValue = _props.defaultValue,
          value = _props.value,
          className = _props.className,
          disabled = _props.disabled,
          theme = _props.theme,
          size = _props.size,
          status = _props.status,
          placeholder = _props.placeholder,
          restProps = _objectWithoutProperties(_props, ['defaultValue', 'value', 'className', 'disabled', 'theme', 'size', 'status', 'placeholder']);

      var _state = this.state,
          selectedIdx = _state.selectedIdx,
          focused = _state.focused;
      var select = style.select,
          selectValue = style.selectValue,
          selectValueSelected = style.selectValueSelected;


      var allowedAttributes = getAllowedAttributes(restProps);

      var classNames = cx(select({ theme: theme, size: size, status: status, focused: focused, disabled: disabled }), className);

      var valueClassName = cx(selectValue, _defineProperty({}, selectValueSelected, selectedIdx !== -1));

      return React.createElement(
        'div',
        _extends({ className: classNames }, allowedAttributes),
        React.createElement(
          'span',
          { 'data-test-id': 'SelectNative__value', className: valueClassName },
          this.childrenLabels[selectedIdx] || placeholder || defaultValue || value
        ),
        React.createElement(ArrowDown, null),
        this.renderNativeSelect()
      );
    }
  }]);

  return SelectNative;
}(PureComponent);

SelectNative.propTypes = commonPropTypes;
SelectNative.defaultProps = {
  disabled: false
};
export default SelectNative;